import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'
import Zhaopin from '@/components/zhaopin'
import Aboutcom from '@/components/aboutcom'
import Technology from '@/components/technology'
import Solve from '@/components/solve'
import Product from '@/components/product'
import Saltout from '@/components/saltout'
import Contactu from '@/components/contactu'
import Case from '@/components/case'
import Newsdetail from '@/components/newsdetail'

import AboutcomCulture from '@/components/aboutcom/aboutcom-culture.vue'
import AboutcomHonor from '@/components/aboutcom/aboutcom-honor.vue'
import AboutcomInfo from '@/components/aboutcom/aboutcom-info.vue'
import AboutcomNews from '@/components/aboutcom/aboutcom-news.vue'
import AboutcomOrg from '@/components/aboutcom/aboutcom-org.vue'

import TechnologyBusiness from '@/components/technology/technology-business.vue'
import TechnologyField from '@/components/technology/technology-field.vue'
import TechnologyService from '@/components/technology/technology-service.vue'

Vue.use(Router)

export default new Router({
  mode : 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Zhaopin',
      name: 'Zhaopin',
      component: Zhaopin
    },
    {
      path: '/Aboutcom/:ID',
      name: 'Aboutcom',
      component: Aboutcom
    },
    {
      path: '/AboutcomCulture',
      name: 'AboutcomCulture',
      component: AboutcomCulture
    },
    {
      path: '/AboutcomHonor',
      name: 'AboutcomHonor',
      component: AboutcomHonor
    },
    {
      path: '/AboutcomInfo',
      name: 'AboutcomInfo',
      component: AboutcomInfo
    },
    {
      path: '/AboutcomNews',
      name: 'AboutcomNews',
      component: AboutcomNews
    },
    {
      path: '/AboutcomOrg',
      name: 'AboutcomOrg',
      component: AboutcomOrg
    },
    {
      path: '/Technology/:ID',
      name: 'Technology',
      component: Technology
    },
    {
      path: '/TechnologyBusiness',
      name: 'TechnologyBusiness',
      component: TechnologyBusiness
    },
    {
      path: '/TechnologyField',
      name: 'TechnologyField',
      component: TechnologyField
    },
    {
      path: '/TechnologyService',
      name: 'TechnologyService',
      component: TechnologyService
    },
    {
      path: '/Solve/:ID',
      name: 'Solve',
      component: Solve
    },
    {
      path: '/Solve',
      name: 'Solve',
      component: Solve
    },
    {
      path: '/Product/:ID',
      name: 'Product',
      component: Product
    },
    {
      path: '/Product/',
      name: 'Product',
      component: Product
    },
    {
      path: '/Saltout',
      name: 'Saltout',
      component: Saltout
    },
    {
      path: '/Contactu',
      name: 'Contactu',
      component: Contactu
    },
    {
      path: '/Case',
      name: 'Case',
      component: Case
    },
    {
      path: '/Newsdetail/:ID',
      name: 'Newsdetail',
      component: Newsdetail
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js